export const _mod10 = (num) => {
  const t = [0, 9, 4, 6, 8, 2, 7, 1, 3, 5];
  let c = 0;
  for (const ch of String(num)) c = t[(c + (parseInt(ch, 10) || 0)) % 10];
  return (10 - c) % 10;
};

export const refQR = (id) => {
  const d = String(id || '').replace(/\D/g, '') || '0';
  const base = ('0'.repeat(26) + d).slice(-26);
  return base + _mod10(base);
};

export const refQRfmt = (id) => {
  const r = refQR(id);
  let out = '';
  for (let i = r.length; i > 0; i -= 5) {
    out = r.slice(Math.max(0, i - 5), i) + ' ' + out;
  }
  return out.trim();
};

export const ibanIID = (iban) => {
  const c = String(iban || '')
    .replace(/\s/g, '')
    .toUpperCase();
  return /^CH/.test(c) && c.length >= 9 ? parseInt(c.slice(4, 9), 10) : NaN;
};

export const isQRIban = (iban) => {
  const iid = ibanIID(iban);
  return iid >= 30000 && iid <= 31999;
};

export const _mod97 = (str) => {
  let r = 0;
  for (const ch of String(str)) {
    r = (r * 10 + (parseInt(ch, 10) || 0)) % 97;
  }
  return r;
};

export const refSCOR = (id) => {
  const base =
    String(id || '')
      .replace(/[^0-9A-Za-z]/g, '')
      .toUpperCase() || '0';
  const conv = (base + 'RF00').replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
  const chk = String(98 - _mod97(conv)).padStart(2, '0');
  return 'RF' + chk + base;
};

export const refSCORfmt = (id) =>
  refSCOR(id)
    .replace(/(.{4})/g, '$1 ')
    .trim();

export const docRef = (id, iban) =>
  isQRIban(iban)
    ? { type: 'QRR', ref: refQR(id), aff: refQRfmt(id), nom: 'Référence QR (QRR)' }
    : { type: 'SCOR', ref: refSCOR(id), aff: refSCORfmt(id), nom: 'Référence (SCOR)' };

export const refQRR = (seed) => refQRfmt(seed);
